<template>
  <div class="empty-wrap">
    <img
      :class="[size === 'small' ? 'small-img' : 'large-img']"
      src="https://editor.xesimg.com/tailor/resource/empty-1698397452109.png"
      alt=""
    />
    <p :class="[size === 'small' ? 'small-msg' : 'large-msg']">
      {{ msg }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "small",
    },
    msg: {
      type: String,
      default: "暂无数据",
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.empty-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.small-img {
  width: 93px;
  height: 96px;
}
.large-img {
  width: 133px;
  height: 137px;
}
.small-msg {
  margin-top: 11px;
  color: #666;
  text-align: center;
  font-family: PingFang SC;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.large-msg {
  .small-msg;
  margin-top: 36px;
}
</style>
